import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const OrganizationHero = ({ organization, onContactClick, onVolunteerClick }) => {
  return (
    <div className="relative bg-gradient-to-br from-primary/5 via-secondary/5 to-accent/5 overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-primary rounded-full blur-3xl" />
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary rounded-full blur-3xl" />
      </div>
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12 items-center">
          <div className="space-y-6">
            <div className="flex items-center gap-3">
              <div className="w-16 h-16 rounded-xl bg-gradient-to-br from-primary to-secondary flex items-center justify-center shadow-lg">
                <Icon name={organization?.icon} size={32} color="white" />
              </div>
              <div>
                <h1 className="text-3xl lg:text-4xl font-bold text-foreground">
                  {organization?.name}
                </h1>
                <p className="text-sm text-muted-foreground mt-1">
                  {organization?.category} • Est. {organization?.established}
                </p>
              </div>
            </div>

            <p className="text-lg text-foreground leading-relaxed">
              {organization?.mission}
            </p>

            <div className="flex flex-wrap gap-2">
              {organization?.tags?.map((tag, index) => (
                <span
                  key={index}
                  className="px-3 py-1 bg-primary/10 text-primary text-sm font-medium rounded-full"
                >
                  {tag}
                </span>
              ))}
            </div>

            <div className="grid grid-cols-3 gap-4 pt-4">
              {organization?.stats?.map((stat, index) => (
                <div key={index} className="text-center">
                  <div className="text-2xl lg:text-3xl font-bold text-primary">
                    {stat?.value}
                  </div>
                  <div className="text-xs lg:text-sm text-muted-foreground mt-1">
                    {stat?.label}
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-wrap gap-3 pt-2">
              <Button
                variant="default"
                size="lg"
                iconName="Heart"
                iconPosition="left"
                onClick={onVolunteerClick}
              >
                Volunteer Now
              </Button>
              <Button
                variant="outline"
                size="lg"
                iconName="Mail"
                iconPosition="left"
                onClick={onContactClick}
              >
                Contact Us
              </Button>
            </div>
          </div>

          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <Image
                src={organization?.heroImage}
                alt={organization?.heroImageAlt}
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-4 -right-4 bg-white dark:bg-card p-4 rounded-xl shadow-lg">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-success/10 flex items-center justify-center">
                  <Icon name="CheckCircle" size={24} color="var(--color-success)" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground">Verified Nonprofit</div>
                  <div className="text-xs text-muted-foreground">501(c)(3) Status</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationHero;